import { allOptionValues, normalizeCheckedSelections, selectionSetsEqual } from "../../utils/checkedSelections.js";

// The URL retains legacy empty-means-all arrays plus explicit-none flags.
// Resolve defaults only for presentation; never write asynchronous options
// back into the URL simply because they arrived.
export function capacityCheckedSelections(state, dimensions) {
  return normalizeCheckedSelections(dimensions, Object.fromEntries(dimensions.map(({ id }) => [
    id, state[`${id}None`] ? [] : state[id]?.length ? [...new Set(state[id])] : undefined,
  ])));
}

export function capacityPredicateState(state, dimensions, selections, countGroup = null) {
  const next = { ...state };
  for (const dim of dimensions) {
    const values = selections[dim.id];
    const all = allOptionValues(dim);
    const unrestricted = dim.id !== countGroup && selectionSetsEqual(values, all)
      // A legacy explicit region list can equal today's option inventory but
      // still exclude unclassified markets. Preserve that URL's restriction;
      // an intentional All/Default action instead clears the raw list.
      && !(dim.id === "region" && state.region?.length)
      && (all.length > 0 || !state[`${dim.id}None`]);
    next[dim.id] = unrestricted ? [] : values;
    next[`${dim.id}None`] = !unrestricted && values.length === 0;
  }
  return next;
}

export function capacitySelectionPatch(dimensions, current, next) {
  const patch = {};
  for (const dim of dimensions) {
    const values = next[dim.id] ?? [];
    // Preserve untouched raw intent, especially while regions are loading,
    // and preserve unknown legacy restrictions rather than dropping them.
    if (selectionSetsEqual(values, current[dim.id])) continue;
    const atDefault = selectionSetsEqual(values, allOptionValues(dim));
    patch[dim.id] = atDefault ? [] : values;
    patch[`${dim.id}None`] = !atDefault && values.length === 0;
  }
  return patch;
}
